import React from "react";
import styles from "./Imprint.module.css";

export default function Imprint() {
return (
  <div className={styles.container}>
    <div>
      <h1>Imprint</h1>

      <p>
        Company Name: RisingDSP <br />
        Address: Jahnstraße 14, 6020, Innsbruck <br />
        Email: info@risingdsp.com
      </p>

      <h2>Managing Director</h2>
      <p>Ludwig Messerer</p>

      <h2>Commercial Register</h2>
      <p>Innsbruck</p>

      <h2>VAT</h2>
      <p>ATU83080915</p>
    </div>
  </div>
);
}